import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ForexComponent } from './forex.component';
import { NbButtonModule, NbCardModule, NbIconModule, NbAccordionModule, NbSpinnerModule } from '@nebular/theme';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ForexMoreComponent } from '../forex-more/forex-more.component';
// const component = ForexComponent



@NgModule({
  declarations: [ForexComponent, ForexMoreComponent],
  imports: [
    CommonModule,
    NbIconModule,
    NbCardModule,
    FlexLayoutModule,
    NbButtonModule,
    NbAccordionModule,
    NbSpinnerModule
  ],
  exports: [ForexComponent, ForexMoreComponent]
})
export class ForexModule { }
